// extracted by mini-css-extract-plugin
module.exports = {"list":"Teams_list__3Jn0U"};